// Contract between SideNav's chat buttons and the view that owns the drawers (CommandCenter.vue).
//
//   SideNav  ──chat-open {kind}──▶  host view opens the matching drawer
//   host view ──chat-unread n────▶  SideNav shows the badge
//
// Who answers: a role dashboard that docks the chats (sidebarChatBridge.js registers it while
// it's mounted), otherwise SidebarChatHost.vue (mounted once in App.vue), which opens the same
// drawers on whatever page you're on. SideNav no longer navigates to "/" first; that sent
// people back to the dashboard and, on the views with no dock (Opportunity, Underwrite,
// Insights, Pipeline Board), nothing opened at all.

import bus from "@/helpers/appBus.js"

export const CHAT_OPEN_EVENT = "chat-open"
export const CHAT_UNREAD_EVENT = "chat-unread"
export const CHAT_KIND_SWIFT = "swiftchat"
export const CHAT_KIND_LOANLAUNCH = "loanlaunch"

let pending = null
let dockHosts = 0

// A dashboard with its own chat dock is on screen (sidebarChatBridge mounted / unmounted).
export function registerChatHost() {
  dockHosts += 1
}

export function unregisterChatHost() {
  dockHosts = Math.max(0, dockHosts - 1)
}

export function hasChatHost() {
  return dockHosts > 0
}

// The bus is synchronous, so whoever is mounted has answered by the time emit() returns.
// Nothing is left pending, so a dashboard mounted later doesn't pop a chat open on its own.
export function requestOpenChat(kind) {
  pending = null
  bus.emit(CHAT_OPEN_EVENT, kind)
}

// Kept for sidebarChatBridge's mounted(); always null now that nothing navigates first.
export function consumePendingChat() {
  const k = pending
  pending = null
  return k
}

export function publishChatUnread(n) {
  bus.emit(CHAT_UNREAD_EVENT, Number(n) || 0)
}
